import { Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { AgentListData, AgentPagedList, FilterPayload, getAgentList } from 'api/agent';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import moment from 'moment';
import { useEffect, useState } from 'react';
//import Table, { ColumnsType } from "antd/lib/table";

let payPagedList: AgentPagedList;

type Props = {
  filter: FilterPayload;
  setOnlyDigitError: (error: boolean) => void;
};
const AgentList = ({ filter, setOnlyDigitError }: Props) => {
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(false);

  filter.Username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');
  filter.PageNo = 1;
  filter.PageSize = 10;

  if (isAdmin != 'true') {
    filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  }
  useEffect(() => {
    setIsLoading(false);
    setPagedList(payPagedList);

    getAgentList(filter)
      .then((res) => {
        setPagedList(res.data);
        setOnlyDigitError(false);
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, [filter]);

  const columns: ColumnsType<AgentListData> = [
    {
      key: 'PaymentRequestId',
      title: 'PaymentRequestID',
      dataIndex: 'PaymentRequestId',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      className: '',
    },
    {
      key: 'LanNumber',
      title: 'LoanNumber',
      dataIndex: 'LanNumber',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'TotalAmount',
      title: 'Amount',
      dataIndex: 'TotalAmount',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'ShortLink',
      title: 'ShortLink',
      dataIndex: 'ShortLink',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PAYMENTPURPOSE',
      title: 'Payment Purpose',
      dataIndex: 'PAYMENTPURPOSE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },

    {
      key: 'EmailTo',
      title: 'EmailTo',
      dataIndex: 'EmailTo',
      ellipsis: true,
      width: 250,
    },
    {
      key: 'Email_ApplicantType',
      title: 'Email-ApplicantType',
      dataIndex: 'Email_ApplicantType',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'EmailID',
      title: 'EmailID',
      dataIndex: 'EmailID',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'EmailSentDate',
      title: 'Email Sent Date & Time',
      dataIndex: 'EmailSentDate',
      ellipsis: true,
      render: (date: string) => getFullDate(date),
      //onFilter: (value: any, record: { PAYMENTPURPOSE: string | any[]; }) => record.PAYMENTPURPOSE.indexOf(value) === 0,
    },
    {
      key: 'EmailStatus',
      title: 'Email Status',
      dataIndex: 'EmailStatus',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'SMSTo',
      title: 'SMS To',
      dataIndex: 'SMSTo',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'SMS_ApplicantType',
      title: 'SMS-ApplicantType',
      dataIndex: 'SMS_ApplicantType',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),

      //onFilter: (value: any, record: { RequestStatus: string | any[]; }) => record.RequestStatus.indexOf(value) === 0,
    },
    {
      key: 'ContactNo',
      title: 'Contact No',
      dataIndex: 'ContactNo',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      //onFilter: (value: any, record: { NEW_STATUS: string | any[]; }) => record.NEW_STATUS.indexOf(value) === 0,
    },
    {
      key: 'SMSSentDate',
      title: 'SMS Sent Date & Time',
      dataIndex: 'SMSSentDate',
      ellipsis: true,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'SMSStatus',
      title: 'SMS Status',
      dataIndex: 'SMSStatus',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'ByAgent',
      title: 'ByAgent',
      dataIndex: 'ByAgent',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'VerificationReason',
      title: 'Verification Reason',
      dataIndex: 'VerificationReason',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'AgentRejectRemarks',
      title: 'Agent Reject Remarks',
      dataIndex: 'AgentRejectRemarks',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
  ];

  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);

    filter.Username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    }

    filter.PageNo = _pagination.current;
    filter.PageSize = _pagination.pageSize;
    getAgentList(filter).then((res) => {
      setPagedList(res.data);
      setIsLoading(true);
    });
  };

  function getFullDate(date: string) {
    if (date != null) {
      let dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
      return dateMoment;
    }
  }

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(columns, pagedList.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        pagination={{
          pageSize: 10,
          total: pagedList.noOfRecords,
          current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
      ;
    </>
  );
};

export default AgentList;
